module.exports = __webpack_public_path__ + "static/media/33.e38c73c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/33.jpg
// module id = 980
// module chunks = 0